"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FR = void 0;
exports.FR = {
    numericCode: '250',
    alpha2Code: 'FR',
    alpha3Code: 'FRA',
    englishName: {
        short: 'France',
        full: 'the French Republic',
    },
    names: {
        full: {
            en: 'the French Republic',
            fr: 'la République française',
        },
        short: {
            en: 'France',
            fr: 'France (la)',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'FR-ARA': {
            numericCode: '250',
            code: 'FR-ARA',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Auvergne-Rhône-Alpes',
            },
        },
        'FR-01': {
            numericCode: '250',
            code: 'FR-01',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Ain',
            },
        },
        'FR-03': {
            numericCode: '250',
            code: 'FR-03',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Allier',
            },
        },
        'FR-07': {
            numericCode: '250',
            code: 'FR-07',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Ardèche',
            },
        },
        'FR-15': {
            numericCode: '250',
            code: 'FR-15',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Cantal',
            },
        },
        'FR-26': {
            numericCode: '250',
            code: 'FR-26',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Drôme',
            },
        },
        'FR-38': {
            numericCode: '250',
            code: 'FR-38',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Isère',
            },
        },
        'FR-42': {
            numericCode: '250',
            code: 'FR-42',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Loire',
            },
        },
        'FR-43': {
            numericCode: '250',
            code: 'FR-43',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Haute-Loire',
            },
        },
        'FR-63': {
            numericCode: '250',
            code: 'FR-63',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Puy-de-Dôme',
            },
        },
        'FR-69': {
            numericCode: '250',
            code: 'FR-69',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Rhône',
            },
        },
        'FR-73': {
            numericCode: '250',
            code: 'FR-73',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Savoie',
            },
        },
        'FR-74': {
            numericCode: '250',
            code: 'FR-74',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Haute-Savoie',
            },
        },
        'FR-69M': {
            numericCode: '250',
            code: 'FR-69M',
            category: {
                id: '475',
                names: {
                    en: {
                        singular: 'metropolitan collectivity with special status',
                        plural: 'metropolitan collectivities with special status',
                    },
                    fr: {
                        singular: 'collectivité métropolitaine à statut particulier',
                        plural: '',
                    },
                },
            },
            parent: 'FR-ARA',
            names: {
                fr: 'Métropole de Lyon',
            },
        },
        'FR-BFC': {
            numericCode: '250',
            code: 'FR-BFC',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Bourgogne-Franche-Comté',
            },
        },
        'FR-21': {
            numericCode: '250',
            code: 'FR-21',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: "Côte-d'Or",
            },
        },
        'FR-25': {
            numericCode: '250',
            code: 'FR-25',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: 'Doubs',
            },
        },
        'FR-39': {
            numericCode: '250',
            code: 'FR-39',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: 'Jura',
            },
        },
        'FR-58': {
            numericCode: '250',
            code: 'FR-58',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: 'Nièvre',
            },
        },
        'FR-70': {
            numericCode: '250',
            code: 'FR-70',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: 'Haute-Saône',
            },
        },
        'FR-71': {
            numericCode: '250',
            code: 'FR-71',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: 'Saône-et-Loire',
            },
        },
        'FR-89': {
            numericCode: '250',
            code: 'FR-89',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: 'Yonne',
            },
        },
        'FR-90': {
            numericCode: '250',
            code: 'FR-90',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BFC',
            names: {
                fr: 'Territoire de Belfort',
            },
        },
        'FR-BRE': {
            numericCode: '250',
            code: 'FR-BRE',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Bretagne',
            },
        },
        'FR-22': {
            numericCode: '250',
            code: 'FR-22',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BRE',
            names: {
                fr: "Côtes-d'Armor",
            },
        },
        'FR-29': {
            numericCode: '250',
            code: 'FR-29',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BRE',
            names: {
                fr: 'Finistère',
            },
        },
        'FR-35': {
            numericCode: '250',
            code: 'FR-35',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BRE',
            names: {
                fr: 'Ille-et-Vilaine',
            },
        },
        'FR-56': {
            numericCode: '250',
            code: 'FR-56',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-BRE',
            names: {
                fr: 'Morbihan',
            },
        },
        'FR-CVL': {
            numericCode: '250',
            code: 'FR-CVL',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Centre-Val de Loire',
            },
        },
        'FR-18': {
            numericCode: '250',
            code: 'FR-18',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-CVL',
            names: {
                fr: 'Cher',
            },
        },
        'FR-28': {
            numericCode: '250',
            code: 'FR-28',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-CVL',
            names: {
                fr: 'Eure-et-Loir',
            },
        },
        'FR-36': {
            numericCode: '250',
            code: 'FR-36',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-CVL',
            names: {
                fr: 'Indre',
            },
        },
        'FR-37': {
            numericCode: '250',
            code: 'FR-37',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-CVL',
            names: {
                fr: 'Indre-et-Loire',
            },
        },
        'FR-41': {
            numericCode: '250',
            code: 'FR-41',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-CVL',
            names: {
                fr: 'Loir-et-Cher',
            },
        },
        'FR-45': {
            numericCode: '250',
            code: 'FR-45',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-CVL',
            names: {
                fr: 'Loiret',
            },
        },
        'FR-GES': {
            numericCode: '250',
            code: 'FR-GES',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Grand-Est',
            },
        },
        'FR-08': {
            numericCode: '250',
            code: 'FR-08',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Ardennes',
            },
        },
        'FR-10': {
            numericCode: '250',
            code: 'FR-10',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Aube',
            },
        },
        'FR-51': {
            numericCode: '250',
            code: 'FR-51',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Marne',
            },
        },
        'FR-52': {
            numericCode: '250',
            code: 'FR-52',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Haute-Marne',
            },
        },
        'FR-54': {
            numericCode: '250',
            code: 'FR-54',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Meurthe-et-Moselle',
            },
        },
        'FR-55': {
            numericCode: '250',
            code: 'FR-55',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Meuse',
            },
        },
        'FR-57': {
            numericCode: '250',
            code: 'FR-57',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Moselle',
            },
        },
        'FR-88': {
            numericCode: '250',
            code: 'FR-88',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Vosges',
            },
        },
        'FR-6AE': {
            numericCode: '250',
            code: 'FR-6AE',
            category: {
                id: '493',
                names: {
                    en: {
                        singular: 'European collectivity',
                        plural: 'European collectivities',
                    },
                    fr: {
                        singular: 'collectivité européenne',
                        plural: '',
                    },
                },
            },
            parent: 'FR-GES',
            names: {
                fr: 'Alsace',
            },
        },
        'FR-67': {
            numericCode: '250',
            code: 'FR-67',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-6AE',
            names: {
                fr: 'Bas-Rhin',
            },
        },
        'FR-68': {
            numericCode: '250',
            code: 'FR-68',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-6AE',
            names: {
                fr: 'Haut-Rhin',
            },
        },
        'FR-HDF': {
            numericCode: '250',
            code: 'FR-HDF',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Hauts-de-France',
            },
        },
        'FR-02': {
            numericCode: '250',
            code: 'FR-02',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-HDF',
            names: {
                fr: 'Aisne',
            },
        },
        'FR-59': {
            numericCode: '250',
            code: 'FR-59',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-HDF',
            names: {
                fr: 'Nord',
            },
        },
        'FR-60': {
            numericCode: '250',
            code: 'FR-60',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-HDF',
            names: {
                fr: 'Oise',
            },
        },
        'FR-62': {
            numericCode: '250',
            code: 'FR-62',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-HDF',
            names: {
                fr: 'Pas-de-Calais',
            },
        },
        'FR-80': {
            numericCode: '250',
            code: 'FR-80',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-HDF',
            names: {
                fr: 'Somme',
            },
        },
        'FR-IDF': {
            numericCode: '250',
            code: 'FR-IDF',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Île-de-France',
            },
        },
        'FR-77': {
            numericCode: '250',
            code: 'FR-77',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: 'Seine-et-Marne',
            },
        },
        'FR-78': {
            numericCode: '250',
            code: 'FR-78',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: 'Yvelines',
            },
        },
        'FR-91': {
            numericCode: '250',
            code: 'FR-91',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: 'Essonne',
            },
        },
        'FR-92': {
            numericCode: '250',
            code: 'FR-92',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: 'Hauts-de-Seine',
            },
        },
        'FR-93': {
            numericCode: '250',
            code: 'FR-93',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: 'Seine-Saint-Denis',
            },
        },
        'FR-94': {
            numericCode: '250',
            code: 'FR-94',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: 'Val-de-Marne',
            },
        },
        'FR-95': {
            numericCode: '250',
            code: 'FR-95',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: "Val-d'Oise",
            },
        },
        'FR-75C': {
            numericCode: '250',
            code: 'FR-75C',
            category: {
                id: '475',
                names: {
                    en: {
                        singular: 'metropolitan collectivity with special status',
                        plural: 'metropolitan collectivities with special status',
                    },
                    fr: {
                        singular: 'collectivité métropolitaine à statut particulier',
                        plural: '',
                    },
                },
            },
            parent: 'FR-IDF',
            names: {
                fr: 'Paris',
            },
        },
        'FR-NAQ': {
            numericCode: '250',
            code: 'FR-NAQ',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Nouvelle-Aquitaine',
            },
        },
        'FR-16': {
            numericCode: '250',
            code: 'FR-16',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Charente',
            },
        },
        'FR-17': {
            numericCode: '250',
            code: 'FR-17',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Charente-Maritime',
            },
        },
        'FR-19': {
            numericCode: '250',
            code: 'FR-19',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Corrèze',
            },
        },
        'FR-23': {
            numericCode: '250',
            code: 'FR-23',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Creuse',
            },
        },
        'FR-24': {
            numericCode: '250',
            code: 'FR-24',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Dordogne',
            },
        },
        'FR-33': {
            numericCode: '250',
            code: 'FR-33',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Gironde',
            },
        },
        'FR-40': {
            numericCode: '250',
            code: 'FR-40',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Landes',
            },
        },
        'FR-47': {
            numericCode: '250',
            code: 'FR-47',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Lot-et-Garonne',
            },
        },
        'FR-64': {
            numericCode: '250',
            code: 'FR-64',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Pyrénées-Atlantiques',
            },
        },
        'FR-79': {
            numericCode: '250',
            code: 'FR-79',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Deux-Sèvres',
            },
        },
        'FR-86': {
            numericCode: '250',
            code: 'FR-86',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Vienne',
            },
        },
        'FR-87': {
            numericCode: '250',
            code: 'FR-87',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NAQ',
            names: {
                fr: 'Haute-Vienne',
            },
        },
        'FR-NOR': {
            numericCode: '250',
            code: 'FR-NOR',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Normandie',
            },
        },
        'FR-14': {
            numericCode: '250',
            code: 'FR-14',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NOR',
            names: {
                fr: 'Calvados',
            },
        },
        'FR-27': {
            numericCode: '250',
            code: 'FR-27',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NOR',
            names: {
                fr: 'Eure',
            },
        },
        'FR-50': {
            numericCode: '250',
            code: 'FR-50',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NOR',
            names: {
                fr: 'Manche',
            },
        },
        'FR-61': {
            numericCode: '250',
            code: 'FR-61',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NOR',
            names: {
                fr: 'Orne',
            },
        },
        'FR-76': {
            numericCode: '250',
            code: 'FR-76',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-NOR',
            names: {
                fr: 'Seine-Maritime',
            },
        },
        'FR-OCC': {
            numericCode: '250',
            code: 'FR-OCC',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Occitanie',
            },
        },
        'FR-09': {
            numericCode: '250',
            code: 'FR-09',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Ariège',
            },
        },
        'FR-11': {
            numericCode: '250',
            code: 'FR-11',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Aude',
            },
        },
        'FR-12': {
            numericCode: '250',
            code: 'FR-12',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Aveyron',
            },
        },
        'FR-30': {
            numericCode: '250',
            code: 'FR-30',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Gard',
            },
        },
        'FR-31': {
            numericCode: '250',
            code: 'FR-31',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Haute-Garonne',
            },
        },
        'FR-32': {
            numericCode: '250',
            code: 'FR-32',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Gers',
            },
        },
        'FR-34': {
            numericCode: '250',
            code: 'FR-34',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Hérault',
            },
        },
        'FR-46': {
            numericCode: '250',
            code: 'FR-46',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Lot',
            },
        },
        'FR-48': {
            numericCode: '250',
            code: 'FR-48',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Lozère',
            },
        },
        'FR-65': {
            numericCode: '250',
            code: 'FR-65',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Hautes-Pyrénées',
            },
        },
        'FR-66': {
            numericCode: '250',
            code: 'FR-66',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Pyrénées-Orientales',
            },
        },
        'FR-81': {
            numericCode: '250',
            code: 'FR-81',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Tarn',
            },
        },
        'FR-82': {
            numericCode: '250',
            code: 'FR-82',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-OCC',
            names: {
                fr: 'Tarn-et-Garonne',
            },
        },
        'FR-PAC': {
            numericCode: '250',
            code: 'FR-PAC',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Provence-Alpes-Côte-d’Azur',
            },
        },
        'FR-04': {
            numericCode: '250',
            code: 'FR-04',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PAC',
            names: {
                fr: 'Alpes-de-Haute-Provence',
            },
        },
        'FR-05': {
            numericCode: '250',
            code: 'FR-05',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PAC',
            names: {
                fr: 'Hautes-Alpes',
            },
        },
        'FR-06': {
            numericCode: '250',
            code: 'FR-06',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PAC',
            names: {
                fr: 'Alpes-Maritimes',
            },
        },
        'FR-13': {
            numericCode: '250',
            code: 'FR-13',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PAC',
            names: {
                fr: 'Bouches-du-Rhône',
            },
        },
        'FR-83': {
            numericCode: '250',
            code: 'FR-83',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PAC',
            names: {
                fr: 'Var',
            },
        },
        'FR-84': {
            numericCode: '250',
            code: 'FR-84',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PAC',
            names: {
                fr: 'Vaucluse',
            },
        },
        'FR-PDL': {
            numericCode: '250',
            code: 'FR-PDL',
            category: {
                id: '240',
                names: {
                    en: {
                        singular: 'metropolitan region',
                        plural: 'metropolitan regions',
                    },
                    fr: {
                        singular: 'région métropolitaine',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Pays-de-la-Loire',
            },
        },
        'FR-44': {
            numericCode: '250',
            code: 'FR-44',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PDL',
            names: {
                fr: 'Loire-Atlantique',
            },
        },
        'FR-49': {
            numericCode: '250',
            code: 'FR-49',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PDL',
            names: {
                fr: 'Maine-et-Loire',
            },
        },
        'FR-53': {
            numericCode: '250',
            code: 'FR-53',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PDL',
            names: {
                fr: 'Mayenne',
            },
        },
        'FR-72': {
            numericCode: '250',
            code: 'FR-72',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PDL',
            names: {
                fr: 'Sarthe',
            },
        },
        'FR-85': {
            numericCode: '250',
            code: 'FR-85',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-PDL',
            names: {
                fr: 'Vendée',
            },
        },
        'FR-CP': {
            numericCode: '250',
            code: 'FR-CP',
            category: {
                id: '305',
                names: {
                    en: {
                        singular: 'dependency',
                        plural: 'dependencies',
                    },
                    fr: {
                        singular: 'dépendance',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Clipperton',
            },
        },
        'FR-BL': {
            numericCode: '250',
            code: 'FR-BL',
            category: {
                id: '368',
                names: {
                    en: {
                        singular: 'overseas collectivity',
                        plural: 'overseas collectivities',
                    },
                    fr: {
                        singular: "collectivité d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Saint-Barthélemy (see also separate country code entry under BL)',
            },
        },
        'FR-MF': {
            numericCode: '250',
            code: 'FR-MF',
            category: {
                id: '368',
                names: {
                    en: {
                        singular: 'overseas collectivity',
                        plural: 'overseas collectivities',
                    },
                    fr: {
                        singular: "collectivité d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Saint-Martin (see also separate country code entry under MF)',
            },
        },
        'FR-PF': {
            numericCode: '250',
            code: 'FR-PF',
            category: {
                id: '368',
                names: {
                    en: {
                        singular: 'overseas collectivity',
                        plural: 'overseas collectivities',
                    },
                    fr: {
                        singular: "collectivité d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Polynésie française (see also separate country code entry under PF)',
            },
        },
        'FR-PM': {
            numericCode: '250',
            code: 'FR-PM',
            category: {
                id: '368',
                names: {
                    en: {
                        singular: 'overseas collectivity',
                        plural: 'overseas collectivities',
                    },
                    fr: {
                        singular: "collectivité d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Saint-Pierre-et-Miquelon (see also separate country code entry under PM)',
            },
        },
        'FR-WF': {
            numericCode: '250',
            code: 'FR-WF',
            category: {
                id: '368',
                names: {
                    en: {
                        singular: 'overseas collectivity',
                        plural: 'overseas collectivities',
                    },
                    fr: {
                        singular: "collectivité d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Wallis-et-Futuna (see also separate country code entry under WF)',
            },
        },
        'FR-20R': {
            numericCode: '250',
            code: 'FR-20R',
            category: {
                id: '475',
                names: {
                    en: {
                        singular: 'metropolitan collectivity with special status',
                        plural: 'metropolitan collectivities with special status',
                    },
                    fr: {
                        singular: 'collectivité métropolitaine à statut particulier',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Corse',
            },
        },
        'FR-2A': {
            numericCode: '250',
            code: 'FR-2A',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-20R',
            names: {
                fr: 'Corse-du-Sud',
            },
        },
        'FR-2B': {
            numericCode: '250',
            code: 'FR-2B',
            category: {
                id: '151',
                names: {
                    en: {
                        singular: 'metropolitan department',
                        plural: 'metropolitan departments',
                    },
                    fr: {
                        singular: 'département métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'FR-20R',
            names: {
                fr: 'Haute-Corse',
            },
        },
        'FR-NC': {
            numericCode: '250',
            code: 'FR-NC',
            category: {
                id: '489',
                names: {
                    en: {
                        singular: 'overseas collectivity with special status',
                        plural: 'overseas collectivities with special status ',
                    },
                    fr: {
                        singular: 'collectivité d’outre-mer à statut particulier',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Nouvelle-Calédonie (see also separate country code entry under NC)',
            },
        },
        'FR-TF': {
            numericCode: '250',
            code: 'FR-TF',
            category: {
                id: '490',
                names: {
                    en: {
                        singular: 'overseas territory',
                        plural: 'overseas territories',
                    },
                    fr: {
                        singular: "territoire d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Terres australes françaises (see also separate country code entry under TF)',
            },
        },
        'FR-972': {
            numericCode: '250',
            code: 'FR-972',
            category: {
                id: '494',
                names: {
                    en: {
                        singular: 'overseas unique territorial collectivity',
                        plural: 'overseas unique territorial collectivities',
                    },
                    fr: {
                        singular: "collectivité territoriale unique d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Martinique (see also separate country code entry under MQ)',
            },
        },
        'FR-973': {
            numericCode: '250',
            code: 'FR-973',
            category: {
                id: '494',
                names: {
                    en: {
                        singular: 'overseas unique territorial collectivity',
                        plural: 'overseas unique territorial collectivities',
                    },
                    fr: {
                        singular: "collectivité territoriale unique d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Guyane (française) (see also separate country code entry under GF)',
            },
        },
        'FR-971': {
            numericCode: '250',
            code: 'FR-971',
            category: {
                id: '495',
                names: {
                    en: {
                        singular: 'overseas departmental collectivity',
                        plural: 'overseas departemental collectivities',
                    },
                    fr: {
                        singular: "collectivité départementale d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Guadeloupe (see also separate country code entry under GP)',
            },
        },
        'FR-974': {
            numericCode: '250',
            code: 'FR-974',
            category: {
                id: '495',
                names: {
                    en: {
                        singular: 'overseas departmental collectivity',
                        plural: 'overseas departemental collectivities',
                    },
                    fr: {
                        singular: "collectivité départementale d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'La Réunion (see also separate country code entry under RE)',
            },
        },
        'FR-976': {
            numericCode: '250',
            code: 'FR-976',
            category: {
                id: '495',
                names: {
                    en: {
                        singular: 'overseas departmental collectivity',
                        plural: 'overseas departemental collectivities',
                    },
                    fr: {
                        singular: "collectivité départementale d'outre-mer",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                fr: 'Mayotte (see also separate country code entry under YT)',
            },
        },
    },
    cities: [
        {
            name: 'Yerres',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Wittenheim',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Wattrelos',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Wasquehal',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Voiron',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Vitry-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Vitry-le-François',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Vitrolles',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Vitré',
            subdivision: 'Brittany',
        },
        {
            name: 'Viry-Châtillon',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Viroflay',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Vincennes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villiers-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villiers-le-Bel',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villeurbanne',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Villers-lès-Nancy',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Villepinte',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villeparisis',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villeneuve-sur-Lot',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Villeneuve-Saint-Georges',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villeneuve-le-Roi',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villeneuve-la-Garenne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villenave-d’Ornon',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Villemomble',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villejuif',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Villefranche-sur-Saône',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Villefontaine',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Vigneux-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Vierzon',
            subdivision: 'Centre',
        },
        {
            name: 'Vienne',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Vichy',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Vesoul',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Vertou',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Versailles',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Verrières-le-Buisson',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Vernon',
            subdivision: 'Normandy',
        },
        {
            name: 'Verneuil-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Verdun',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Vénissieux',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Vendôme',
            subdivision: 'Centre',
        },
        {
            name: 'Vence',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Vélizy-Villacoublay',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Vauréal',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Vaulx-en-Velin',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Vanves',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Vannes',
            subdivision: 'Brittany',
        },
        {
            name: 'Vandœuvre-lès-Nancy',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Vallauris',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Valenciennes',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Valence',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Tulle',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Troyes',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Tremblay-en-France',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Trappes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Tours',
            subdivision: 'Centre',
        },
        {
            name: 'Tournefeuille',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Tourlaville',
            subdivision: 'Normandy',
        },
        {
            name: 'Tourcoing',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Toulouse',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Toulon',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Toul',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Torcy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Thonon-les-Bains',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Thionville',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Thiais',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Tergnier',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Taverny',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Tassin-la-Demi-Lune',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Tarbes',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Talence',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Suresnes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Sucy-en-Brie',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Strasbourg',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Stains',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Sotteville-lès-Rouen',
            subdivision: 'Normandy',
        },
        {
            name: 'Sorgues',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Soisy-sous-Montmorency',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Soissons',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Six-Fours-les-Plages',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Sin-le-Noble',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Seynod',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Sèvres',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Sevran',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Sète',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Sens',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Senlis',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Sélestat',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Sedan',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Schiltigheim',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Sceaux',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Savigny-sur-Orge',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Savigny-le-Temple',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saumur',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Sartrouville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Sarreguemines',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Sarcelles',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saran',
            subdivision: 'Centre',
        },
        {
            name: 'Sannois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Sanary-sur-Mer',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Salon-de-Provence',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Sallanches',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Sébastien-sur-Loire',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Saint-Raphaël',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Saint-Quentin',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Saint-Priest',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Pol-sur-Mer',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Saint-Pierre-des-Corps',
            subdivision: 'Centre',
        },
        {
            name: 'Saint-Ouen-l’Aumône',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Ouen',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Omer',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Saint-Nazaire',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Saint-Michel-sur-Orge',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Médard-en-Jalles',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Saint-Maximin-la-Sainte-Baume',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Saint-Maur-des-Fossés',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Martin-d’Hères',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Mandé',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Malo',
            subdivision: 'Brittany',
        },
        {
            name: 'Saint-Louis',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Saint-Lô',
            subdivision: 'Normandy',
        },
        {
            name: 'Saint-Leu-la-Forêt',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Leu',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Saint-Laurent-du-Var',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Saint-Jean-de-la-Ruelle',
            subdivision: 'Centre',
        },
        {
            name: 'Saint-Jean-de-Braye',
            subdivision: 'Centre',
        },
        {
            name: 'Saint-Herblain',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Saint-Gratien',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Germain-en-Laye',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Genis-Laval',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Fons',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Étienne-du-Rouvray',
            subdivision: 'Normandy',
        },
        {
            name: 'Saint-Étienne',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saintes',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Sainte-Geneviève-des-Bois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Sainte-Foy-lès-Lyon',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Égrève',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Dizier',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Saint-Dié-des-Vosges',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Saint-Denis',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Cyr-sur-Loire',
            subdivision: 'Centre',
        },
        {
            name: 'Saint-Cyr-l’École',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Cloud',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Chamond',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Saint-Brieuc',
            subdivision: 'Brittany',
        },
        {
            name: 'Saint-Avold',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Saint-Avertin',
            subdivision: 'Centre',
        },
        {
            name: 'Saint-Amand-les-Eaux',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Rueil-Malmaison',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Royan',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Rouen',
            subdivision: 'Normandy',
        },
        {
            name: 'Roubaix',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Rosny-sous-Bois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Ronchin',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Romorantin-Lanthenay',
            subdivision: 'Centre',
        },
        {
            name: 'Romans-sur-Isère',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Romainville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Roissy-en-Brie',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Rodez',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Rochefort',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Roanne',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Ris-Orangis',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Riom',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Rillieux-la-Pape',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Rezé',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Rennes',
            subdivision: 'Brittany',
        },
        {
            name: 'Reims',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Rambouillet',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Quimper',
            subdivision: 'Brittany',
        },
        {
            name: 'Puteaux',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Port-de-Bouc',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Pontoise',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Pontivy',
            subdivision: 'Brittany',
        },
        {
            name: 'Pontarlier',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Pont-à-Mousson',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Poitiers',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Poissy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Ploemeur',
            subdivision: 'Brittany',
        },
        {
            name: 'Plaisir',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Plaisance-du-Touch',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Pierrefitte-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Pessac',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Pertuis',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Perpignan',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Périgueux',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Pau',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Paris',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Pantin',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Pamiers',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Palaiseau',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Ozoir-la-Ferrière',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Oyonnax',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Outreau',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Oullins',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Osny',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Orvault',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Orsay',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Orly',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Orléans',
            subdivision: 'Centre',
        },
        {
            name: 'Orange',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Olivet',
            subdivision: 'Centre',
        },
        {
            name: 'Octeville',
            subdivision: 'Normandy',
        },
        {
            name: 'Noyon',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Noisy-le-Sec',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Noisy-le-Grand',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Noisiel',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Nogent-sur-Oise',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Nogent-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Niort',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Nîmes',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Nice',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Nevers',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Neuilly-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Neuilly-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Neuilly-Plaisance',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Narbonne',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Nantes',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Nanterre',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Nancy',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Muret',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Mulhouse',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Moulins',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Mougins',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Morsang-sur-Orge',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Morlaix',
            subdivision: 'Brittany',
        },
        {
            name: 'Mont-Saint-Aignan',
            subdivision: 'Normandy',
        },
        {
            name: 'Montrouge',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montreuil',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montpellier',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Montmorency',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montluçon',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Montivilliers',
            subdivision: 'Normandy',
        },
        {
            name: 'Montigny-lès-Metz',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Montigny-lès-Cormeilles',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montigny-le-Bretonneux',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montgeron',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montfermeil',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montesson',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montereau-Fault-Yonne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Montélimar',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Mont-de-Marsan',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Montceau-les-Mines',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Montbrison',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Montbéliard',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Montauban',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Montargis',
            subdivision: 'Centre',
        },
        {
            name: 'Mons-en-Barœul',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Moissy-Cramayel',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Mitry-Mory',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Miramas',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Millau',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Meyzieu',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Meylan',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Meudon',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Metz',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Mérignac',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Menton',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Melun',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Meaux',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Mayenne',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Maurepas',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Mauguio',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Maubeuge',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Massy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Martigues',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marmande',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Marly-le-Roi',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Marignane',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marcq-en-Barœul',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Mantes-la-Ville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Mantes-la-Jolie',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Manosque',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Mandelieu-la-Napoule',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Malakoff',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Maisons-Laffitte',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Maisons-Alfort',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Mâcon',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Lyon',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Lunéville',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Lunel',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Lucé',
            subdivision: 'Centre',
        },
        {
            name: 'Louviers',
            subdivision: 'Normandy',
        },
        {
            name: 'Lourdes',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Lormont',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Lorient',
            subdivision: 'Brittany',
        },
        {
            name: 'Loos',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Lons-le-Saunier',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Longjumeau',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Lomme',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Lognes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Livry-Gargan',
            subdivision: 'Île-de-France',
        },
        {
            name: 'L’Isle-sur-la-Sorgue',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Lisieux',
            subdivision: 'Normandy',
        },
        {
            name: 'Lingolsheim',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Limoges',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Limeil-Brévannes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Limay',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Lille',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Liévin',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Libourne',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: "L'Haÿ-les-Roses",
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Vésinet',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Levallois-Perret',
            subdivision: 'Île-de-France',
        },
        {
            name: "Les Sables-d'Olonne",
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Les Pennes-Mirabeau',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Les Pavillons-sous-Bois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Les Mureaux',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Les Lilas',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Les Herbiers',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Les Clayes-sous-Bois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Puy-en-Velay',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Le Pré-Saint-Gervais',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Pontet',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Le Plessis-Trévise',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Plessis-Robinson',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Petit-Quevilly',
            subdivision: 'Normandy',
        },
        {
            name: 'Le Perreux-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Pecq',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Lens',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Le Mée-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Mans',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Le Kremlin-Bicêtre',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Havre',
            subdivision: 'Normandy',
        },
        {
            name: 'Le Grand-Quevilly',
            subdivision: 'Normandy',
        },
        {
            name: 'Le Creusot',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Le Chesnay',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Le Cannet',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Le Bouscat',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Le Blanc-Mesnil',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Laxou',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'La Valette-du-Var',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Laval',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Lattes',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'La Teste-de-Buch',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'La Seyne-sur-Mer',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'La Roche-sur-Yon',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'La Rochelle',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Laon',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Lannion',
            subdivision: 'Brittany',
        },
        {
            name: 'Lanester',
            subdivision: 'Brittany',
        },
        {
            name: 'Landerneau',
            subdivision: 'Brittany',
        },
        {
            name: 'Lambersart',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'La Madeleine',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Lagny-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'La Garenne-Colombes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'La Garde',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'La Flèche',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'La Crau',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'La Courneuve',
            subdivision: 'Île-de-France',
        },
        {
            name: 'La Ciotat',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'La Chapelle-sur-Erdre',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'La Celle-Saint-Cloud',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Jouy-le-Moutier',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Joué-lés-Tours',
            subdivision: 'Centre',
        },
        {
            name: 'Joinville-le-Pont',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Ivry-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Istres',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Issy-les-Moulineaux',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Issoire',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Illzach',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Illkirch-Graffenstaden',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Hyères',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Houilles',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Hérouville-Saint-Clair',
            subdivision: 'Normandy',
        },
        {
            name: 'Herblay',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Hénin-Beaumont',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Hem',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Hazebrouck',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Hayange',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Hautmont',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Yutz',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Haubourdin',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Halluin',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Haguenau',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Guyancourt',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Gujan-Mestras',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Guéret',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Guérande',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Grigny',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Grenoble',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Grasse',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Grande-Synthe',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Gradignan',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Goussainville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Gonesse',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Givors',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Gif-sur-Yvette',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Gien',
            subdivision: 'Centre',
        },
        {
            name: 'Gentilly',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Gennevilliers',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Garges-lès-Gonesse',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Gardanne',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Garches',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Gap',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Gagny',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Frontignan',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Fresnes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Fréjus',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Franconville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Fougères',
            subdivision: 'Brittany',
        },
        {
            name: 'Fos-sur-Mer',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Forbach',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Fontenay-sous-Bois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Fontenay-le-Comte',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Fontenay-aux-Roses',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Fontainebleau',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Fontaine',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Floirac',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Fleury-les-Aubrais',
            subdivision: 'Centre',
        },
        {
            name: 'Flers',
            subdivision: 'Normandy',
        },
        {
            name: 'Firminy',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Fécamp',
            subdivision: 'Normandy',
        },
        {
            name: 'Faches-Thumesnil',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Eysines',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Évry',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Évreux',
            subdivision: 'Normandy',
        },
        {
            name: 'Étampes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'La Baule-Escoublac',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Ermont',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Éragny',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Équeurdreville-Hainneville',
            subdivision: 'Normandy',
        },
        {
            name: 'Épinay-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Épinal',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Épernay',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Elbeuf',
            subdivision: 'Normandy',
        },
        {
            name: 'Élancourt',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Écully',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Échirolles',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Eaubonne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Dunkerque',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Dreux',
            subdivision: 'Centre',
        },
        {
            name: 'Draveil',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Drancy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Draguignan',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Douarnenez',
            subdivision: 'Brittany',
        },
        {
            name: 'Douai',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Domont',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Dole',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Dijon',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Digne-les-Bains',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Dieppe',
            subdivision: 'Normandy',
        },
        {
            name: 'Deuil-la-Barre',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Denain',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Décines-Charpieu',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Dax',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Dammarie-les-Lys',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Cugnaux',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Croix',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Créteil',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Crépy-en-Valois',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Creil',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Cran-Gevrier',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Cournon-d’Auvergne',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Courbevoie',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Coulommiers',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Couëron',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Coudekerque-Branche',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Cormeilles-en-Parisis',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Corbeil-Essonnes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Conflans-Sainte-Honorine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Concarneau',
            subdivision: 'Brittany',
        },
        {
            name: 'Compiègne',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Combs-la-Ville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Pontault-Combault',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Colomiers',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Colombes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Colmar',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Cognac',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Cluses',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Clichy-sous-Bois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Clichy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Clermont-Ferrand',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Clamart',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Cholet',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Choisy-le-Roi',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Chilly-Mazarin',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Chevilly-Larue',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Cherbourg-Octeville',
            subdivision: 'Normandy',
        },
        {
            name: 'Chenôve',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Chennevières-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Chelles',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Chaville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Chaumont',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Chatou',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Châtillon',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Châtenay-Malabry',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Châtellerault',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Château-Thierry',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Châteauroux',
            subdivision: 'Centre',
        },
        {
            name: 'Châteaudun',
            subdivision: 'Centre',
        },
        {
            name: 'Chartres',
            subdivision: 'Centre',
        },
        {
            name: 'Charleville-Mézières',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Charenton-le-Pont',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Champs-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Champigny-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Chambéry',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Chamalières',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Chalon-sur-Saône',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Châlons-en-Champagne',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Challans',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Cestas',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Cesson-Sévigné',
            subdivision: 'Brittany',
        },
        {
            name: 'Cergy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Cenon',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Cavaillon',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Castres',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Castelnau-le-Lez',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Carvin',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Carrières-sous-Poissy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Carquefou',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Carpentras',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Carcassonne',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Canteleu',
            subdivision: 'Normandy',
        },
        {
            name: 'Cannes',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Cambrai',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Caluire-et-Cuire',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Calais',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Cahors',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Cagnes-sur-Mer',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Caen',
            subdivision: 'Normandy',
        },
        {
            name: 'Cachan',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bry-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Brunoy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bruay-la-Buissière',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Bron',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Brive-la-Gaillarde',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Brignoles',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Brie-Comte-Robert',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Brétigny-sur-Orge',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Brest',
            subdivision: 'Brittany',
        },
        {
            name: 'Bressuire',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Bourgoin',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Bourg-lès-Valence',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Bourg-la-Reine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bourges',
            subdivision: 'Centre',
        },
        {
            name: 'Bourg-en-Bresse',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Boulogne-sur-Mer',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Boulogne-Billancourt',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bouguenais',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Bordeaux',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Bonneuil-sur-Marne',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bondy',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Boissy-Saint-Léger',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bois-Colombes',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bobigny',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Blois',
            subdivision: 'Centre',
        },
        {
            name: 'Blanquefort',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Blagnac',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Bischheim',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Biarritz',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Bezons',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Béziers',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Béthune',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Besançon',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Bergerac',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Berck',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Berck-Plage',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Belfort',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Bègles',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Beauvais',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Beaune',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Bayonne',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Bayeux',
            subdivision: 'Normandy',
        },
        {
            name: 'Bastia',
            subdivision: 'Corsica',
        },
        {
            name: 'Bar-le-Duc',
            subdivision: 'Alsace-Champagne-Ardenne-Lorraine',
        },
        {
            name: 'Balma',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Bagnols-sur-Cèze',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Bagnolet',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bagneux',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Avon',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Avion',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Avignon',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Auxerre',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Autun',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Aurillac',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Aulnay-sous-Bois',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Audincourt',
            subdivision: 'Bourgogne-Franche-Comté',
        },
        {
            name: 'Auch',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Aubervilliers',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Aubagne',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Athis-Mons',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Asnières-sur-Seine',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Arras',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Armentières',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Arles',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Argenteuil',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Argentan',
            subdivision: 'Normandy',
        },
        {
            name: 'Arcueil',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Antony',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Antibes',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Annonay',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Annemasse',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Annecy-le-Vieux',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Annecy',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Angoulême',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Anglet',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Angers',
            subdivision: 'Pays de la Loire',
        },
        {
            name: 'Amiens',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Allauch',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Alfortville',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Alès',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Alençon',
            subdivision: 'Normandy',
        },
        {
            name: 'Albi',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Albertville',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Ajaccio',
            subdivision: 'Corsica',
        },
        {
            name: 'Aix-les-Bains',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Aix-en-Provence',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Agen',
            subdivision: 'Aquitaine-Limousin-Poitou-Charentes',
        },
        {
            name: 'Agde',
            subdivision: 'Languedoc-Roussillon-Midi-Pyrénées',
        },
        {
            name: 'Achères',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Abbeville',
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: "Villeneuve-d'Ascq",
            subdivision: 'Nord-Pas-de-Calais-Picardie',
        },
        {
            name: 'Les Ulis',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Bourgoin-Jallieu',
            subdivision: 'Auvergne-Rhône-Alpes',
        },
        {
            name: 'Marseille 01',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 02',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 03',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 04',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 05',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 06',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 07',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 08',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 10',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 09',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 11',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 12',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 13',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 14',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 15',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'Marseille 16',
            subdivision: "Provence-Alpes-Côte d'Azur",
        },
        {
            name: 'La Defense',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Saint-Quentin-en-Yvelines',
            subdivision: 'Île-de-France',
        },
        {
            name: 'Cergy-Pontoise',
            subdivision: 'Île-de-France',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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